import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { JsonSchemaInfoBasePropertiesFormProperties } from "../models/campaign-3.model";
import { FormFields } from "../components/form-fields/form-fields.component";
import { Campaign3TestService } from "../services/campaign3testservice";
import { Campaign3 } from "app/models/campaign3.model";
import { CalendarTranslateService } from "app/modules/UIKit/services/calendarTranslate.service";
import { MessageService } from "primeng/primeng";
import { TranslateService } from "@ngx-translate/core";


@Component({
  selector: 'app-edit-campaign-3',
  templateUrl: './edit-campaign-3.component.html',
  styleUrls: ['./edit-campaign-3.component.css']
})
export class EditCampaign3Component implements OnInit {

  @Input() formSchema: JsonSchemaInfoBasePropertiesFormProperties;

  fieldModel = {
    campaign_name: null,
    campaign_description: null,
    start_date: null,
    end_date: null,
    budget_type: null,
    budget_value: null,
    campaign_type: null,
    status: null
  }

  errors = {
    campaign_name: false,
    status: false,
    start_date: false,
    end_date: false,
    campaign_type: false,
    campaign_description: false,
    budget_type: false,
    budget_value: false
  };



  @Output() refreshPage = new EventEmitter();
  @Output() closeEditPopup = new EventEmitter<any>();

  @Input() campaign;
  @Input() campaignStartDate;
  @Input() campaignEndDate;
  @Input() budgetTypeList: Array<{ label: string, value: number }> = [];
  @Input() campaignTypeList: Array<{ label: string, value: number }> = [];
  @Input() statusList: Array<{ label: string, value: number }> = [];
  @ViewChild('start_date') start_date: FormFields;
  @ViewChild('end_date') end_date: FormFields;
  @ViewChild('campaign_name') campaign_name: FormFields;
  @ViewChild('campaign_description') campaign_description: FormFields;
  @ViewChild('budget_type') budget_type: FormFields;
  @ViewChild('budget_value') budget_value: FormFields;
  @ViewChild('campaign_type') campaign_type: FormFields;


  popupMessage: string = '';

  constructor(
    public testService: Campaign3TestService,
    private srvNotify: MessageService,
    private translateService: TranslateService,
    public srvCalendar: CalendarTranslateService) {

  }
 
 

  ngOnInit() {
    this.setEditData();
}

  setEditData() {
    try {
      // Filtra la lista per rimuovere gli elementi con label vuota
      this.campaignTypeList = this.campaignTypeList.filter(item => item.label.trim() !== '');
      this.statusList = this.statusList.filter(item => item.label.trim() !== '');
      this.budgetTypeList = this.budgetTypeList.filter(item => item.label.trim() !== '');

      if (this.campaign) {
        this.fieldModel.campaign_name = this.campaign.name;
        this.fieldModel.campaign_description = this.campaign.description;
        this.fieldModel.start_date = this.reverseDateConverter(this.campaign.start_date);
        this.fieldModel.end_date = this.reverseDateConverter(this.campaign.end_date);

        const budgetType = this.budgetTypeList.find(x => x.value == this.campaign.budget_type_id);
        this.fieldModel.budget_type = budgetType ? budgetType : null;

        this.fieldModel.budget_value = this.campaign.budget;

        const campaignType = this.campaignTypeList.find(x => x.value == this.campaign.campaign_type_id);
        this.fieldModel.campaign_type = campaignType ? campaignType : null;

        const status = this.statusList.find(x => x.value == this.campaign.campaign_status_id);
        this.fieldModel.status = status ? status : null;

        // Verifica se uno dei campi di fieldModel è null
        if (
          this.fieldModel.campaign_name === null ||
          this.fieldModel.campaign_description === null ||
          this.fieldModel.start_date === null ||
          this.fieldModel.end_date === null ||
          this.fieldModel.budget_type === null ||
          this.fieldModel.budget_value === null ||
          this.fieldModel.campaign_type === null ||
          this.fieldModel.status === null
        ) {
          console.error("One or more required fields in fieldModel are null.");



          throw new Error("Missing required fields in fieldModel. Aborting operation.");
        }
      }
    } catch (error) {
      console.error(error);
      this.srvNotify.add({
        severity: 'error',
        summary: 'Error',
        detail: this.translateService.instant('campaign.field_model_null'),
        life: 5000
      });
      this.onClosePopup(); // Chiude il popup in caso di errore
      // Propaga l'errore per ulteriori gestioni
    }
  }

onClosePopup() {
    this.closeEditPopup.emit();
}


  validateDataFields() {


    if (isNaN(Date.parse(this.fieldModel.start_date))) {
      console.error('start_date non è una data valida!');
      this.errors.start_date = true;
      this.start_date.valid = false;
      
    }

    if (isNaN(Date.parse(this.fieldModel.end_date))) {
      console.error('end_date non è una data valida!');
      this.errors.end_date = true;
      this.end_date.valid = false;
     
    }



    // Controllo della relazione tra start_date e end_date
    if (this.fieldModel.start_date && this.fieldModel.end_date) {

      const startDate = new Date(this.fieldModel.start_date);
      const endDate = new Date(this.fieldModel.end_date);

      // Crea una data di oggi senza tempo (ore, minuti, secondi)
      const today = new Date();
      today.setHours(0, 0, 0, 0);  // Rimuove l'orario

      // Reset degli errori
      this.errors.start_date = false;
      this.errors.end_date = false;

      // Controllo se la start_date è successiva o uguale a end_date
      if (startDate >= endDate) {
        this.errors.start_date = true;
        this.errors.end_date = true;

        this.start_date.valid = false;
        this.start_date.errorMessage = "Incongruenza tra data di inizio e di fine"

        this.end_date.valid = false;
        this.end_date.errorMessage = "Incongruenza tra data di inizio e di fine"
      }

      // Controllo se end_date è nel passato
      if (endDate < today) {
        this.errors.end_date = true;

        this.end_date.valid = false;
        this.end_date.errorMessage = "Attenazione! Data di fine è nel passato"
      }
    }


  }

  getStatusDescription(statusValue: number): string {
    let description = "";
    let index = this.statusList.findIndex(x => x.value == statusValue);
    if (index > -1) {
      description = this.statusList[index].label;
    } else {
      console.log("errore nel trovare la descrizione degli stati");
    }
    return description;
  }


  validateModel() {

    this.errors.campaign_name = !this.fieldModel.campaign_name || this.fieldModel.campaign_name.trim() === '',
      this.errors.status = !this.fieldModel.status,
      this.errors.campaign_type = !this.fieldModel.campaign_type,
      this.errors.campaign_description = !this.fieldModel.campaign_description || this.fieldModel.campaign_description.trim() === '',
      this.errors.budget_type = !this.fieldModel.budget_type,
      this.errors.budget_value = !this.fieldModel.budget_value

    for (const field in this.errors) {
      if (Object.prototype.hasOwnProperty.call(this.errors, field)) {
        console.log(`${field}: ${this.errors[field]}`);
      }
    }
  }

  onEditData() {

    this.validateModel();
    this.campaign_name.performValidation();
    this.campaign_description.performValidation();
    this.budget_type.performValidation();
    this.budget_value.performValidation();
    this.campaign_type.performValidation();
    this.start_date.performValidation();
    this.end_date.performValidation();

    this.validateDataFields();

    const errorValues = Object.keys(this.errors).map(key => this.errors[key]);
    const hasErrors = errorValues.some(error => error);

    // Se ci sono errori, non salvare l'entità e aprire popup
    if (hasErrors) {
      console.log("abort saving, there are some errors", this.fieldModel);
      for (const key in this.errors) {
        if (Object.prototype.hasOwnProperty.call(this.errors, key)) {
          this.errors[key] = false;
        }
      }
      return;
    }

    let campaignId = this.campaign.id;
    let editedCampaign = new Campaign3();

    editedCampaign.name = this.fieldModel.campaign_name;
    editedCampaign.code = this.campaign.code;
    editedCampaign.start_date = this.dateConverter(this.fieldModel.start_date);
    editedCampaign.end_date = this.dateConverter(this.fieldModel.end_date);
    editedCampaign.campaign_type_id = this.fieldModel.campaign_type.value;
    editedCampaign.description = this.fieldModel.campaign_description;
    editedCampaign.budget_type_id = this.fieldModel.budget_type.value;
    editedCampaign.campaign_status_id = this.fieldModel.status.value;
    editedCampaign.budget = this.fieldModel.budget_value;
    editedCampaign.priority = 0; // Valore di priorità predefinito

    // Salva la campagna modificata
    this.testService.editCampaign(editedCampaign, campaignId).subscribe(
      (res) => {
        console.log("risultati di salvataggio campagna", res);
        this.closeEditPopup.emit();
        this.refreshPage.emit();
      },
      (error) => {
        console.error("Si è verificato un errore durante il salvataggio della campagna modificata:", error);
      }
    );
  }

  reverseDateConverter(dateString) {
    try {
      const [anno, mese, giorno] = dateString.split('-');
      const data = new Date(`${anno}-${mese}-${giorno}`);
      return data;
    } catch (error) {
      console.error('Si è verificato un errore durante la conversione inversa della data:', error);
      return null; // Ritorna null in caso di errore
    }
  }
  dateConverter(event) {
    try {
      const data = new Date(event);
      const giorno = data.getDate();
      const mese = data.getMonth() + 1;
      const anno = data.getFullYear();
      const giornoFormattato = giorno < 10 ? '0' + giorno : giorno;
      const meseFormattato = mese < 10 ? '0' + mese : mese;
      return anno + '-' + meseFormattato + '-' + giornoFormattato;
    } catch (error) {
      console.error('Si è verificato un errore durante la conversione della data:', error);
      return null; // Ritorna null in caso di errore
    }
  }




}


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/edit-campaign-3/edit-campaign-3.component.ts